/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';

import './component004.less';
interface IComponents004Props {
  img: string;
  img1: string;
  className?: string;
}

const Components004: React.FunctionComponent<IComponents004Props> = ({
  img,
  img1,
  className,
}) => (
  <>
    <div className={`RealCase Desktop ${className}`}>
      <img src={require(`../../../../../assets/${img}`).default} alt="" />
      <button
        onClick={() => {
          window.open(
            'https://www.hk01.com/%E7%A4%BE%E6%9C%83%E6%96%B0%E8%81%9E/1011849/%E7%B6%B2%E4%B8%8A%E5%B8%B3%E6%88%B6%E9%A8%8E%E5%8A%AB%E6%A1%88%E6%80%A5%E5%8D%873%E5%80%8B%E6%9C%88%E5%A4%B1%E9%80%BE%E5%8D%83%E8%90%AC-%E9%9B%99%E9%87%8D%E9%A8%8E%E5%8A%ABwhatsapp-%E7%B4%AF%E8%A1%97%E5%9D%8A'
          );
        }}
        className="source1"
      />
    </div>
    <div className={`RealCase Moblie ${className}`}>
      <img src={require(`../../../../../assets/${img1}`).default} alt="" />
      <button
        onClick={() => {
          window.open(
            'https://www.hk01.com/%E7%A4%BE%E6%9C%83%E6%96%B0%E8%81%9E/1011849/%E7%B6%B2%E4%B8%8A%E5%B8%B3%E6%88%B6%E9%A8%8E%E5%8A%AB%E6%A1%88%E6%80%A5%E5%8D%873%E5%80%8B%E6%9C%88%E5%A4%B1%E9%80%BE%E5%8D%83%E8%90%AC-%E9%9B%99%E9%87%8D%E9%A8%8E%E5%8A%ABwhatsapp-%E7%B4%AF%E8%A1%97%E5%9D%8A'
          );
        }}
        className="source1"
      />
    </div>
  </>
);

export default Components004;
